export const TAX_TYPES = [
  { value: "sales_tax", label: "Sales Tax" },
  { value: "gst", label: "GST - Goods and Services Tax" },
  { value: "hst", label: "HST - Harmonized Sales Tax" },
  { value: "pst", label: "PST - Provincial Sales Tax" },
  { value: "qst", label: "QST - Quebec Sales Tax" },
  { value: "rst", label: "RST - Retail Sales Tax" },
  { value: "vat", label: "VAT - Value-Added Tax" },
]
